var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
/**
 * Service which encapsulates configuration functionalities for apps built with Ionic framework.
 */
var ConfigurationService = (function () {
    function ConfigurationService(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get all available keys.
     * @returns all available keys
     */
    /**
         * Get all available keys.
         * @returns all available keys
         */
    ConfigurationService.prototype.getKeys = /**
         * Get all available keys.
         * @returns all available keys
         */
    function () {
        var keys = [];
        // tslint:disable-next-line:forin
        for (var key in this.configValues) {
            keys.push(key);
        }
        return keys;
    };
    /**
     * Get the configuration data for the given key.
     * @param T type of the returned value (default: object)
     * @param key key of the configuration data
     * @returns configuration data for the given key
     */
    /**
         * Get the configuration data for the given key.
         * @param T type of the returned value (default: object)
         * @param key key of the configuration data
         * @returns configuration data for the given key
         */
    ConfigurationService.prototype.getValue = /**
         * Get the configuration data for the given key.
         * @param T type of the returned value (default: object)
         * @param key key of the configuration data
         * @returns configuration data for the given key
         */
    function (key) {
        if (this.configValues) {
            return this.configValues[key];
        }
        else {
            return undefined;
        }
    };
    /**
     * Loads the configuration from the given url.
     * @param configurationUrl url from which the configuration should be loaded
     * @returns promise which gets resolved as soon as the data is loaded; in case of an error, the promise gets rejected
     */
    /**
         * Loads the configuration from the given url.
         * @param configurationUrl url from which the configuration should be loaded
         * @returns promise which gets resolved as soon as the data is loaded; in case of an error, the promise gets rejected
         */
    ConfigurationService.prototype.load = /**
         * Loads the configuration from the given url.
         * @param configurationUrl url from which the configuration should be loaded
         * @returns promise which gets resolved as soon as the data is loaded; in case of an error, the promise gets rejected
         */
    function (configurationUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this.httpClient.get(configurationUrl).toPromise()];
                    case 1:
                        _a.configValues = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        throw new Error(configurationUrl + " could not be loaded: " + e_1.status);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ConfigurationService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    ConfigurationService.ctorParameters = function () { return [
        { type: HttpClient, },
    ]; };
    return ConfigurationService;
}());
export { ConfigurationService };
//# sourceMappingURL=configuration.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-configuration-service/dist/configuration.service.js
// module id = 718
// module chunks = 1